import { RouteNames } from "@/router/routes";

export const checkRouteToPermissionsMap = (routeToPermissionsMap: Map<string, string[]>) => {
	for (const value of Object.values(RouteNames)) {
		if(!routeToPermissionsMap.has(value))
			throw new Error(`Матрица RouteToPermissionsMap не содержит ключ ${value}`);
	}
};
